var YMK = YMK || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.product_vto_v1 = {
    attach: function (context) {
      var $productVTO = $('.product-vto', context);

      if (!$productVTO.length) {
        return;
      }
      var autoTriggerYoucam = window.location.href.indexOf('vto_open') !== -1;
      var hasVtoDiscloseParam = window.location.href.indexOf('vto_disclose') !== -1;
      var showCloseBtn = hasVtoDiscloseParam ? false : true;
      var $youcamButton = $('.js-youcambtn', $productVTO);
      var $ymkModuleCont = $('.product-vto__youcam-module-container', $productVTO);
      var $productImages = $productVTO.siblings('.product-full__images');
      var $mobileShadePick = $('.product-vto__mobile-ctrl', $productVTO);
      var $mobileShadePicker = $('.js-shade-picker-vto');
      var $addToBagButton = $('.js-add-to-cart', $productVTO);
      var $swatches = $('.shade-list-vto').find('.swatch');
      var $INDButton = $('#INDmenu-btn');
      var isMob = site.client.isMobile;
      var currentSkuPcode = $productVTO.attr('data-first-sku-pcode');
      var youcamAPIKey = Drupal.settings.vto.api_key;
      var youcamAPIUrl = Drupal.settings.vto.api_url;
      var language = Drupal.settings.vto.language;
      var enableYoucamButton = false;
      var $LPMimage = $('.LPMimage');
      var youcamEvents = [
        'cameraClosed',
        'cameraFailed',
        'cameraOpened',
        'compare',
        'compareDisabled',
        'closed',
        'engineClosed',
        'loaded',
        'loading',
        'kissDetected',
        'opened',
        'photoLoaded',
        'photoSaved',
        'reset',
        'videoLoaded',
        'shadeFinderStarted',
        'shadeFinderComplete',
        'shadeFinderCancelled',
        'zoom',
        'shareByEmailResult',
        'modelLoaded',
        'skinAnalysisUpdated',
        'split4Way',
        'split4WayDisabled'
      ];

      if (isMob) {
        var VTODiv = $ymkModuleCont.remove();

        VTODiv.appendTo('body');
        site.createAddButton($addToBagButton);
        // set height to screen height
        $ymkModuleCont.height($(window).height());
        $(document).on('addToCart.success', function (e) {
          var addedText = $addToBagButton.data('added-text');
          var atbText = $addToBagButton.html();

          $addToBagButton.html(addedText);
          setTimeout(function () {
            $addToBagButton.html(atbText);
          }, 3000);
        });
      }

      (function (d, k) {
        var s = d.createElement('script');

        s.type = 'text/javascript';
        s.async = true;
        s.src = youcamAPIUrl + k;
        var x = d.getElementsByTagName('script')[0];

        x.parentNode.insertBefore(s, x);
      })(document, youcamAPIKey);

      window.ymkAsyncInit = function (skipEventListener) {
        var vtoParams;
        var disableFBSharing = Drupal?.settings?.globals_variables?.disable_fb_sharing;
        var disableTwitterSharing = Drupal?.settings?.globals_variables?.disable_twitter_sharing;
        var disablePinterestSharing =
          Drupal?.settings?.globals_variables?.disable_pinterest_sharing;

        if (isMob) {
          vtoParams = {
            autoOpen: true,
            skinSmoothStrength: 50,
            showCloseBtnOnLauncher: showCloseBtn,
            ...(disableFBSharing && { enableFBSharing: !disableFBSharing }),
            ...(disableTwitterSharing && { enableTwitterSharing: !disableTwitterSharing }),
            ...(disablePinterestSharing && { enablePinterestSharing: !disablePinterestSharing })
          };
          if (language) {
            vtoParams['language'] = language;
          }
          window.YMK.init(vtoParams);
        } else {
          var ykmWidth = $productVTO.width();

          vtoParams = {
            autoOpen: true,
            skinSmoothStrength: 50,
            showCloseBtnOnLauncher: showCloseBtn,
            width: ykmWidth,
            height: 680,
            ...(disableFBSharing && { enableFBSharing: !disableFBSharing }),
            ...(disableTwitterSharing && { enableTwitterSharing: !disableTwitterSharing }),
            ...(disablePinterestSharing && { enablePinterestSharing: !disablePinterestSharing })
          };
          if (language) {
            vtoParams['language'] = language;
          }
          window.YMK.init(vtoParams);
        }

        if (skipEventListener) {
          return;
        }

        youcamEvents.forEach(function (event) {
          window.YMK.addEventListener(event, function (progress) {
            if (event === 'loaded') {
              // Add current sku
              if (typeof YMK.applyMakeupBySku !== 'undefined') {
                YMK.applyMakeupBySku(currentSkuPcode);
              }
              if (isMob) {
                toggleMobileShadePick('on');
              }
            }

            if (event === 'opened' && autoTriggerYoucam) {
              $youcamButton.addClass('hidden');
            }

            if (event === 'closed') {
              if (isMob) {
                toggleMobileShadePick('off');
              }
              closeYoucamModule();
            }

            // Youcam analytics tagging
            if (site && site.track) {
              var productName, eventName, skuID;
              var data = site.track.refreshData();

              if (
                data &&
                data.product_name &&
                data.product_name.length &&
                data.product_sku &&
                data.product_sku.length
              ) {
                productName = data.product_name[0].replace(/(<([^>]+)>)/gi, '');
                skuID = data.product_sku[0];
              }
              if (event === 'loading') {
                if (progress === 10) {
                  eventName = 'loading-start';
                } else if (progress === 100) {
                  eventName = 'loading-complete';
                }
              } else {
                eventName = event;
              }
              // Setting up currently selected SKU ID
              var selectedSku = $('.js-shade-picker')
                .find('.swatch')
                .filter('.selected')
                .attr('data-sku-base-id');

              if (selectedSku && selectedSku !== '') {
                skuID = 'SKU' + selectedSku;
              }
              if (eventName && eventName !== '') {
                site.track.evtLink({
                  event_name: 'vto',
                  event_category: 'youcam',
                  event_action: eventName,
                  event_label: skuID + ' - ' + productName
                });
              }
            }
          });
        });

        if (autoTriggerYoucam) {
          openYoucamModule();
        }
      };

      function openYoucamModule() {
        var $chatLiveButton = $('.LPMcontainer');

        $youcamButton.addClass('hidden');
        $productImages.addClass('hidden');
        $ymkModuleCont.removeClass('hidden');
        autoTriggerYoucam = 0;
        if (isMob) {
          // dissable scrolling
          window.scrollTo(0, 0);
          $LPMimage.addClass('hidden');
          $('body').addClass('no-scroll');
          $INDButton.addClass('hidden');
          $chatLiveButton.addClass('hidden');
        }
        window.ymkAsyncInit(true);
      }

      function closeYoucamModule() {
        var $chatLiveButton = $('.LPMcontainer');
        var selectedSku = $('.js-shade-picker')
          .find('.swatch')
          .filter('.selected')
          .data('skuBaseId');

        $ymkModuleCont.addClass('hidden');
        $productImages.removeClass('hidden');
        if (enableYoucamButton) {
          $youcamButton.removeClass('hidden');
        }

        if (isMob) {
          // Enable scrolling.
          $LPMimage.removeClass('hidden');
          $('body').removeClass('no-scroll');
          $INDButton.removeClass('hidden');
          $chatLiveButton.removeClass('hidden');
        }

        // reset youcam module
        window.YMK.closeEngine();

        /**
         * This is used to properly re-initialize the image gallery after switching
         * shades on VTO.
         */
        if (selectedSku && selectedSku !== '') {
          changeSKU(selectedSku);
        }
        // reinit slick with the same setting (only if needed).
        if (!$productImages.hasClass('slick-initialized')) {
          $productImages.slick({
            dots: true,
            customPaging: function (slider, i) {
              var thumb = $(slider.$slides[i]).find('img').attr('src');

              return (
                '<div class="js-product-image-thumb product-full__image__thumb" style="background-image: url(' +
                thumb +
                ')"></div>'
              );
            },
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            onAfterChange: function (args) {
              if (Drupal.settings.analytics.analytics_integrated) {
                $(document).trigger('SLICKCHANGE', args.$slides.get(args.currentSlide));
              }
            }
          });
        }

        if (hasVtoDiscloseParam) {
          openYoucamModule();
        }
      }

      function toggleMobileShadePick(state) {
        if (state === 'on') {
          var $activeSwatch = $mobileShadePicker.find('a.selected');

          $mobileShadePick.removeClass('hidden');
          // scroll to active swatch
          $mobileShadePicker.scrollTo($activeSwatch, {
            duration: 350,
            offset: -40
          });
        } else if (state === 'off') {
          $mobileShadePick.addClass('hidden');
        }
      }

      function changeSKU(skuId) {
        var productData = page_data['catalog-spp']['products'][0];
        var skuData = _.find(productData.skus, function (sku) {
          return parseInt(sku.SKU_BASE_ID) === parseInt(skuId);
        });

        site.skuSelect(skuData);
      }

      $swatches.once().on('click', function () {
        var $this = $(this);
        var skuBaseId = $this.data('sku-base-id');

        changeSKU(skuBaseId);
      });

      $('body', context).on('sku:select', function (e, skuData) {
        // update shadename
        var $shadeName = $('.js-shadename', $mobileShadePick);
        var $shadeSwatch = $('.js-current-swatch', $mobileShadePick);
        // update mobile carousel
        var $curMobSwatch = $mobileShadePick.find(
          'a[data-sku-base-id="' + skuData.SKU_BASE_ID + '"]'
        );

        $mobileShadePick.find('a.js-swatch').removeClass('selected');
        $curMobSwatch.addClass('selected');

        $shadeName.html(skuData.SHADENAME);
        $shadeSwatch.css('background-color', skuData.HEX_VALUE_STRING);
        // change the shade
        currentSkuPcode = skuData.PRODUCT_CODE;
        if (YMK && typeof YMK.applyMakeupBySku !== 'undefined') {
          YMK.applyMakeupBySku(skuData.PRODUCT_CODE);
        }
        if (skuData.VTO_FLAG) {
          $youcamButton.removeClass('hidden');
          enableYoucamButton = true;
        } else {
          $youcamButton.addClass('hidden');
          enableYoucamButton = false;
        }
      });

      $youcamButton.once().on('click', function (e) {
        e.preventDefault();
        openYoucamModule();
      });
    }
  };
})(jQuery);
